export default __webpack_public_path__ + "static/media/placeholder_dummy2016-heilpraxis01-de.20b4e18b.png";